import { message } from 'antd';
import React, { useState } from 'react';
import { isEmpty } from 'underscore';
import IconOcean3d from '../../../../assets/icon/Stack.svg';
import IconWave from '../../../../assets/icon/Wave.svg';
import IconWaves from '../../../../assets/icon/Waves.svg';
import IconWind from '../../../../assets/icon/Wind.svg';
import useDeleteShoppingItemMutation from '../../../../queries/useDeleteShoppingItemMutation';
import useGetShoppingCartQuery from '../../../../queries/useGetShoppingCartQuery';
import { DownloadInfoItem } from '../../../../types/analytics';
import { DownloadCheckboxKey } from '../../../../utils/common';
import { DATASET_CATEGORIES } from '../../../../utils/filterBestDataset';
import { IWmsProps } from '../../Map/Layer/DatasetMesh';
import styles from '../Style/DownloadTab.module.scss';
import DatasetInfo from './DatasetInfo';

export default function CategoryAccordion(props: {
  list: DownloadInfoItem[];
  setMeshUrl: (item?: IWmsProps) => void;
  coords: number[];
  markerId: string;
  onMeshControl: (value: string) => any;
  setDatasetIsOfflineWarningVisible: React.Dispatch<React.SetStateAction<boolean>>;
  onAddProductToCart: (
    item: DownloadInfoItem,
    pointName: string,
    category: string,
    coordinates: number[]
  ) => Promise<boolean>;
}) {
  const { data } = useGetShoppingCartQuery();

  const shoppingItems = data?.shoppingItems || {};
  const deleteShoppingItemMutation = useDeleteShoppingItemMutation();

  const [disableDownload, setDisableDownload] = useState(false);

  function findDatasetByCategory(key: string) {
    if (isEmpty(props.list)) {
      return;
    }

    return props.list.find((l) => l.radioKey === key);
  }

  async function triggerRemoveProductFromCart(pointName: string, category: string) {
    const shoppingItemsPerPoint = shoppingItems[pointName];
    if (!shoppingItemsPerPoint) return;

    const shoppingItem = shoppingItemsPerPoint[category];
    if (shoppingItem?.order_id) {
      try {
        const response = await deleteShoppingItemMutation.mutateAsync(shoppingItem.order_id);
        if (!response.Result || response.Result !== 'OK') {
          message.warning('Failed to delete the item from shopping cart');
        }
      } catch (error) {
        message.warning('Failed to delete the item from shopping cart');
      }
    }
  }

  const wavesCategoryItem = findDatasetByCategory(DownloadCheckboxKey.SW);
  const oceanCategoryItem = findDatasetByCategory(DownloadCheckboxKey.HD);
  const windCategoryItem = findDatasetByCategory(DownloadCheckboxKey.Wind);
  const ocean3dCategoryItem = findDatasetByCategory(DownloadCheckboxKey.HD_3D);

  return (
    <div className={styles.downloadRoot}>
      {wavesCategoryItem && (
        <div className={styles.downloadBox}>
          <DatasetInfo
            downloadItems={props.list}
            label={DATASET_CATEGORIES.WAVES}
            item={wavesCategoryItem}
            coords={props.coords}
            markerId={props.markerId}
            onMeshControl={props.onMeshControl}
            onAddProductToCart={props.onAddProductToCart}
            onRemoveProductFromCart={triggerRemoveProductFromCart}
            disableDownload={disableDownload}
            setDisableDownload={setDisableDownload}
            icon={<img src={IconWave} alt="Wave" width={'50px'} height={'50px'} />}
            setDatasetIsOfflineWarningVisible={props.setDatasetIsOfflineWarningVisible}
            namePanel={DownloadCheckboxKey.SW}
            setMeshUrl={props.setMeshUrl}
          />
        </div>
      )}

      {oceanCategoryItem && (
        <div className={styles.downloadBox}>
          <DatasetInfo
            downloadItems={props.list}
            label={DATASET_CATEGORIES.OCEAN}
            item={oceanCategoryItem}
            coords={props.coords}
            markerId={props.markerId}
            onMeshControl={props.onMeshControl}
            onAddProductToCart={props.onAddProductToCart}
            onRemoveProductFromCart={triggerRemoveProductFromCart}
            disableDownload={disableDownload}
            setDisableDownload={setDisableDownload}
            icon={<img src={IconWaves} alt="Waves" width={'50px'} height={'50px'} />}
            setDatasetIsOfflineWarningVisible={props.setDatasetIsOfflineWarningVisible}
            namePanel={DownloadCheckboxKey.HD}
            setMeshUrl={props.setMeshUrl}
          />
        </div>
      )}

      {ocean3dCategoryItem && (
        <div className={styles.downloadBox}>
          <DatasetInfo
            downloadItems={props.list}
            label={DATASET_CATEGORIES.OCEAN_3D}
            item={ocean3dCategoryItem}
            coords={props.coords}
            markerId={props.markerId}
            onMeshControl={props.onMeshControl}
            onAddProductToCart={props.onAddProductToCart}
            onRemoveProductFromCart={triggerRemoveProductFromCart}
            disableDownload={disableDownload}
            setDisableDownload={setDisableDownload}
            icon={<img src={IconOcean3d} alt="Ocean 3D" width={'50px'} height={'50px'} />}
            setDatasetIsOfflineWarningVisible={props.setDatasetIsOfflineWarningVisible}
            namePanel={DownloadCheckboxKey.HD_3D}
            setMeshUrl={props.setMeshUrl}
          />
        </div>
      )}

      {windCategoryItem && (
        <div className={styles.downloadBox}>
          <DatasetInfo
            downloadItems={props.list}
            label={DATASET_CATEGORIES.ATMOSPHERE}
            item={windCategoryItem}
            coords={props.coords}
            markerId={props.markerId}
            onMeshControl={props.onMeshControl}
            onAddProductToCart={props.onAddProductToCart}
            onRemoveProductFromCart={triggerRemoveProductFromCart}
            disableDownload={disableDownload}
            setDisableDownload={setDisableDownload}
            icon={<img src={IconWind} alt="Wind" width={'50px'} height={'50px'} />}
            setDatasetIsOfflineWarningVisible={props.setDatasetIsOfflineWarningVisible}
            namePanel={DownloadCheckboxKey.Wind}
            setMeshUrl={props.setMeshUrl}
          />
        </div>
      )}
    </div>
  );
}
